export default __webpack_public_path__ + "static/media/2.11c8b5dc.jpg";